<template>
  <v-container
          fill-height
          fluid
          grid-list-xl
  >
    <v-layout wrap>
      <v-flex
              md12
              lg12
      >
        <material-card
                class="card-tabs"
                color="green">
          <v-flex
                  slot="header"
          >
            <v-tabs

                    color="transparent"
                    slider-color="white"
            >
              <span
                      class="subheading font-weight-light mr-3"
                      style="align-self: center"
              >Languages:</span>
              <v-tab
                      @click="changeLanguage(1)"
                      class="mr-3">
                English
              </v-tab>
              <v-tab
                      @click="changeLanguage(2)"
                      class="mr-3">
                Chinese
              </v-tab>
              <v-tab
                      @click="changeLanguage(3)"
              >
                French
              </v-tab>
            </v-tabs>
          </v-flex>

          <v-tabs-items v-model="tabs">
            <v-tab-item
                    :key="tabs"
            >
              <v-list three-line>
                <v-list-tile @click="complete(0)">
                  <v-flex
                          md12
                  >
                  <v-data-table
                          :headers="headers"
                          :items="items"
                          hide-actions
                  >
                    <template
                            slot="headerCell"
                            slot-scope="{ header }"
                    >
              <span
                      class="subheading font-weight-light text-success text--darken-3"
                      v-text="header.text"
              />
                    </template>
                    <template
                            slot="items"
                            slot-scope="{ item }"
                    >
                      <td><img :src="item.src"></td>
                      <td>{{ item.title }}</td>
                      <td>{{ item.small_title_1 }}</td>
                      <td>{{ item.small_tip_1 }}</td>
                      <td>{{ item.small_title_2 }}</td>
                      <td>{{ item.small_tip_1 }}</td>
                      <td>{{ item.middle_title }}</td>
                      <td class="text-xs-center">
                        <v-tooltip
                                top
                                content-class="top">
                          <v-btn
                                  slot="activator"
                                  class="v-btn--simple"
                                  color="success"
                                  icon
                          >
                            <v-icon color="primary">mdi-pencil</v-icon>
                          </v-btn>
                          <span>Edit</span>
                        </v-tooltip>
                        <v-tooltip
                                top
                                content-class="top">
                          <v-btn
                                  slot="activator"
                                  class="v-btn--simple"
                                  color="danger"
                                  icon
                          >
                            <v-icon color="error">mdi-close</v-icon>
                          </v-btn>
                          <span>Delete</span>
                        </v-tooltip>

                      </td>
                    </template>
                  </v-data-table>
                    </v-flex>
                </v-list-tile>

              </v-list>
            </v-tab-item>
          </v-tabs-items>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {list } from "../api/routes";
  export default {
    data () {
      return {
        headers: [
          {
            sortable: false,
            text: 'Image',
            value: 'image'
          },
          {
            sortable: false,
            text: 'Title',
            value: 'title'
          },
          {
            sortable: false,
            text: 'Small Titl1',
            value: 'small_title_1',

          },
          {
            sortable: false,
            text: 'Small Tip1',
            value: 'small_tip_1',

          },
          {
            sortable: false,
            text: 'Small Titl2',
            value: 'small_title_1',

          },
          {
            sortable: false,
            text: 'Small Tip2',
            value: 'small_tip_2',

          },
          {
            sortable: false,
            text: 'Middle Title',
            value: 'middle_title',

          },
          {
            sortable: false,
            text: 'Action',
            align: 'center'
          }
        ],
        items:[],
        tabs: 0,
      }
    },
    mounted() {
      if( sessionStorage.getItem('CURRENT_LANGUAGE') == '') {
        sessionStorage.setItem('CURRENT_LANGUAGE', this.tabs ==0?1:this.tabs )
      }
      this.getlist();
    },
    methods: {
      getlist(){
        list()
                .then(response => {
                  console.log(response)
                  this.items =response.data.data;
                })

                .catch(error => {
                  console.log(error);
                })
                .finally(() => {

                })
      },
      changeLanguage (tab) {

        this.tabs = tab;
        sessionStorage.setItem('CURRENT_LANGUAGE', this.tabs ==0?1:this.tabs )
        this.getlist();
      }
    }
  }
</script>
